import styled from "styled-components"

import { colors, spacing } from "@minuthq/meatball-ui-react"

export function ParadiseActionDivider({
  actionContent,
  horizontal,
  disabled,
}: {
  actionContent: React.ReactNode
  horizontal?: boolean
  disabled?: boolean
}) {
  return (
    <Wrapper $disabled={disabled} $horizontal={horizontal}>
      <Line $horizontal={horizontal} />
      <ActionWrapper>{actionContent}</ActionWrapper>
      <Line $horizontal={horizontal} />
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $disabled?: boolean; $horizontal?: boolean }>`
  display: flex;
  flex-direction: ${({ $horizontal }) => ($horizontal ? "row" : "column")};
  align-items: center;
  gap: ${spacing.XS};
  visibility: ${({ $disabled }) => ($disabled ? "hidden" : "visible")};

  opacity: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
`

const ActionWrapper = styled.div`
  display: inline-flex;
`

const Line = styled.div<{ $horizontal?: boolean }>`
  width: ${({ $horizontal }) => ($horizontal ? "100%" : "2px")};
  height: ${({ $horizontal }) => ($horizontal ? "2px" : "100%")};
  background-color: ${colors.primary};
  border-radius: 9999px;
`
